
// ######################################################################
// # THIS FILE HAS BEEN REPURPOSED FOR SUPABASE CONFIGURATION           #
// ######################################################################
//
// Despite the filename, this file no longer contains Firebase config.
// It now holds the configuration for the Supabase client.

// Use 'process.env' if building via CI/CD (Render, Netlify), otherwise use hardcoded strings for local dev.
// The index.html shim ensures process.env exists in the browser.
declare const process: any;

export const supabaseConfig = {
  // -------------------------------------------------------------------------
  // DYNAMIC CONFIGURATION WITH FALLBACK
  // -------------------------------------------------------------------------
  // Priority 1: process.env (Injected by Render/CI Environment Variables)
  // Priority 2: Hardcoded Fallback (Used in AI Studio or Local Development)

  url: process.env['NG_APP_SUPABASE_URL'] || "https://lxsygkivqojahviiygba.supabase.co",
  anonKey: process.env['NG_APP_SUPABASE_ANON_KEY'] || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx4c3lna2l2cW9qYWh2aWl5Z2JhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg5MTQ4NDksImV4cCI6MjA4NDQ5MDg0OX0.HL6nHUM4So_yEnZlEISnAy3muoh0lCHjWLOCDmmE4AM",
};
